/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type ToggleAuditTrailMutationVariables = Types.Exact<{
  orgId: Types.Scalars['String']['input'];
}>;

export type ToggleAuditTrailMutation = {
  __typename?: 'mutation_root';
  toggle_audit_trail?: { __typename?: 'GeneralActionOutput'; message: string } | null;
};

export const ToggleAuditTrailDocument = `
    mutation ToggleAuditTrail($orgId: String!) {
  toggle_audit_trail(object: {orgId: $orgId}) {
    message
  }
}
    ` as string & TypedDocumentNode<ToggleAuditTrailMutation, ToggleAuditTrailMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ToggleAuditTrail: build.mutation<ToggleAuditTrailMutation, ToggleAuditTrailMutationVariables>({
      query: (variables) => ({ document: ToggleAuditTrailDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useToggleAuditTrailMutation } = injectedRtkApi;
